import styled from 'styled-components';

export const StyledInputRequiredStar = styled.span`
  color: ${(props) => props.theme.colors.red};
`;
